module.exports = __webpack_public_path__ + "img/star_off.577cb376.svg";